import { format } from 'date-fns'
import { nl } from 'date-fns/locale'
import { Menu, Search } from 'lucide-react'
import { weekMetaFromDate } from '@/lib/week'

interface TopbarProps {
  onOpenPalette: () => void
  onOpenSidebar: () => void
  now: Date
}

export function Topbar({ onOpenPalette, onOpenSidebar, now }: TopbarProps) {
  const week = weekMetaFromDate(now)

  return (
    <header className="glass sticky top-0 z-30 flex h-14 items-center gap-3 border-b border-hairline px-4 lg:px-8">
      <button
        type="button"
        onClick={onOpenSidebar}
        className="btn-ghost -ml-2 h-9 w-9 p-0 lg:hidden"
        aria-label="Menu openen"
      >
        <Menu className="h-5 w-5" />
      </button>

      {/*
        Dit is een klok, geen paginatitel: hij zegt welke dag het nu is. Eerder stond
        hier alleen "Week 31 · ...", wat op de urenschermen de week tegensprak die je
        aan het bekijken was. Vandaag benoemen haalt die tegenspraak weg.
      */}
      <div className="hidden items-center gap-2 text-sm text-ink-soft sm:flex">
        <span className="font-medium text-ink">{format(now, 'EEEE d MMMM', { locale: nl })}</span>
        <span className="text-ink-faint">·</span>
        <span className="text-ink-faint">{week.label.toLowerCase()}</span>
      </div>

      <div className="ml-auto flex items-center gap-2">
        <button
          type="button"
          onClick={onOpenPalette}
          className="group flex h-9 items-center gap-2 rounded-lg border border-hairline bg-surface px-2.5 text-sm text-ink-faint transition-colors hover:bg-fill-1"
        >
          <Search className="h-4 w-4" />
          <span className="hidden sm:inline">Zoeken…</span>
          <kbd className="ml-1 hidden items-center gap-0.5 rounded-md border border-hairline bg-fill-2 px-1.5 py-0.5 text-[11px] font-medium text-ink-faint sm:inline-flex">
            ⌘K
          </kbd>
        </button>
      </div>
    </header>
  )
}
